import { MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

import { hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter } from '@/shared';
import { useFetchAreas, useUpdateArea} from '@/shared/actions/erp';
import {
  CustomSearch,
  GeneralTable,
  SingleTableBoxScene,
  SwitchComponente,
} from '@/shared/components/ui';
import { Area } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import { useUiConfirmModalStore } from '@/store/ui';

const returnUrl = '/parametrizacion/areas';

export interface AreasPageInterface {}

/**
 * Renders the AreasPage component.
 * 
 * @component
 * @returns JSX.Element
 */

const AreasPage: React.FC<AreasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_view_area);

  const navigate = useNavigate();

  const setConfirmDialog = useUiConfirmModalStore(s => s.setConfirmDialog);
  const setConfirmDialogIsOpen = useUiConfirmModalStore(
    s => s.setConfirmDialogIsOpen
  );
  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
  } = useTableFilter();
  const { pageIndex } = pagination;

  ///* fetch data
  const {
    data: areasPagingRes,
    isLoading,
    isRefetching,
  } = useFetchAreas({
    page: pageIndex + 1,
    nombre: searchTerm,
  });
  useCheckPermissions(PermissionsEnum.api_view_area);

  ///* handlers
  const onEdit = (original: Area) => {
    navigate(`${returnUrl}/editar/${original.id_area}`);
  };
  const updSate = useUpdateArea({
    enableRedirect: false,
  })

  ///* columns
  const columns = useMemo<MRT_ColumnDef<Area>[]>(
    () => [
      {
        accessorKey: 'codigo',
        header: 'Codigo',
        size: 300,
      },
      {
        accessorKey: 'nombre',
        header: 'Nombre',
        size: 300,
      },
      {
        accessorKey: 'empresa',
        header: 'Empresa',
        size: 300,
      },
      {
        accessorKey: 'estado',
        header: 'Estado',
        size: 200,
        enableColumnFilter: false,
        enableSorting: false,
        Cell: ({ row }) => {
          return (
            <SwitchComponente
              estadoSwitch={row.original.estado}
              titulo={row.original.estado ? 'Activo' : 'Inactivo'}
              setEstadoSwitch={state => {
                if (!hasPermission(PermissionsEnum.api_change_area)) return;

                setConfirmDialog({
                  isOpen: true,
                  title: 'Cambiar Estado',
                  subtitle:
                    '¿Está seguro que desea cambiar el estado de este registro ?',
                  onConfirm: () => {
                    setConfirmDialogIsOpen(false);
                    updSate.mutate({
                      id: row.original.id_area!,
                      data: { estado: !!state } as any,
                    });
                  },
                });
              }}
            />
          );
        },
      },
    ],
    []
  );

  return (
    <SingleTableBoxScene title="Areas" urlRedirect={`${returnUrl}/crear`}   enableRedirect={hasPermission(PermissionsEnum.api_add_area)}>
      <CustomSearch onChange={onChangeFilter} value={globalFilter} text="area" />

      <GeneralTable<Area>
        columns={columns}
        data={areasPagingRes?.data?.data || []}
        //
        isLoading={isLoading}
        isRefetching={isRefetching}
        // // search
        enableGlobalFilter={false}
        // // pagination
        pagination={pagination}
        onPaging={setPagination}
        rowCount={areasPagingRes?.data?.count}
        // // actions
        enableColumnActions={hasAllPermissions([
          PermissionsEnum.api_change_area,
        ])}
        // crud
        canEdit={hasAllPermissions([
          PermissionsEnum.api_change_area,
        ])}
        onEdit={onEdit}
        canDelete={false}
      />
    </SingleTableBoxScene>
  );
};

export default AreasPage;
